export const DATA_FIRESTORE_V01_EVENT_PAPERWORK = {
  NAME: 'v01_event_paperwork',
}
